export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_10.585e4e13.jpg";